import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "../Reveal";

export const JournalEntryRow = ({ entry, index, readLabel, readUnit }) => (
  <Reveal
    as="li"
    delay={index * 60}
    data-testid={`journal-entry-${index}`}
    className="group py-8 md:py-14"
  >
    <Link
      to={`/journal/${entry.slug}`}
      className="grid md:grid-cols-12 gap-4 md:gap-10 items-start"
      data-testid={`journal-entry-link-${entry.slug}`}
    >
      <div className="flex md:contents items-center gap-4 md:gap-0">
        <div className="md:col-span-2 overline">{entry.date}</div>
        <div className="md:col-span-2">
          <span className="text-[10px] md:text-[11px] font-mono tracking-[0.18em] uppercase px-3 py-1.5 border border-ink-200 rounded-full text-ink-700">
            {entry.tag}
          </span>
        </div>
      </div>
      <div className="md:col-span-7">
        <h2 className="font-display text-2xl sm:text-3xl md:text-5xl tracking-tightest leading-[1.05] group-hover:translate-x-1 transition-transform duration-500">
          {entry.title}
        </h2>
        <p className="mt-3 md:mt-4 text-[14px] md:text-[15px] text-ink-500 leading-relaxed max-w-2xl">
          {entry.excerpt}
        </p>
        <div className="mt-3 md:mt-4 overline">
          {readLabel} · {entry.readTime} {readUnit}
        </div>
      </div>
      <div className="md:col-span-1 md:justify-self-end">
        <ArrowUpRight
          className="w-5 h-5 md:w-6 md:h-6 text-ink-300 group-hover:text-ink-900 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
          strokeWidth={1.4}
        />
      </div>
    </Link>
  </Reveal>
);
